import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { FormsTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  formStatus: string
  formType: FormsTypeEnum
  anonymous: boolean
}

export const EmptyState: React.FC<Props> = ({ formStatus, formType, anonymous }) => {
  const description =
    formStatus === 'draft'
      ? i18n.t('form_answers.answers_table.empty_state_draft')
      : formType === 'satisfaction' && anonymous
      ? i18n.t('form_answers.answers_table.empty_state_satisfaction')
      : i18n.t('form_answers.answers_table.empty_state_effectiveness')
  const header =
    formStatus === 'draft'
      ? i18n.t('form_answers.answers_table.empty_state_draft_title')
      : i18n.t('data_table.empty_state.data.title')

  return (
    <Box alignItems="center" gap="s16" paddingTop="s40">
      <Icon.Large
        icon={formType === 'satisfaction' && anonymous ? 'visibility' : 'document-folder-drawer-2'}
        color="grey600"
      />
      <Box
        textAlign="center"
        justifyContent="center"
        style={{ width: '50%' }}
        gap="s4"
        alignItems="center"
      >
        <Text.Header2>{header}</Text.Header2>
        <Text.Normal lineClamp={3} color="grey800">
          {description}
        </Text.Normal>
      </Box>
    </Box>
  )
}
